import React from 'react';
import type { FilterState } from './FilterPanel';

interface Props {
  filters: FilterState;
  onChange: (f: FilterState) => void;
}

const TF_LABELS = ['M5', 'M15', 'M30', 'H1'];
const TF_KEYS: Array<'m5' | 'm15' | 'm30' | 'h1'> = ['m5', 'm15', 'm30', 'h1'];
const STOP_LABELS = ['100%', '75%', '50%', '25%'];
const STOP_VALS: FilterState['stopPct'][] = [100, 75, 50, 25];

export default function ORBFilterPanel({ filters, onChange }: Props) {
  const set = (patch: Partial<FilterState>) => onChange({ ...filters, ...patch });

  return (
    <div style={styles.panel}>
      <div style={styles.row}>
        {/* ORB Timeframe */}
        <div style={styles.group}>
          <div style={styles.groupLabel}>ORB Timeframe</div>
          <div style={styles.btnGroup}>
            <button
              style={{ ...styles.toggleBtn, ...(filters.tf === undefined ? styles.toggleBtnActive : {}) }}
              onClick={() => set({ tf: undefined })}
            >All</button>
            {TF_LABELS.map((label, i) => (
              <button
                key={label}
                style={{ ...styles.toggleBtn, ...(filters.tf === TF_KEYS[i] ? styles.toggleBtnActive : {}) }}
                onClick={() => set({ tf: filters.tf === TF_KEYS[i] ? undefined : TF_KEYS[i] })}
              >{label}</button>
            ))}
          </div>
        </div>

        {/* ORB Stop Placement */}
        <div style={styles.group}>
          <div style={styles.groupLabel}>ORB Stop</div>
          <div style={styles.btnGroup}>
            {STOP_VALS.map((val, i) => (
              <button
                key={val}
                style={{ ...styles.toggleBtn, ...(filters.stopPct === val ? styles.toggleBtnActive : {}) }}
                onClick={() => set({ stopPct: filters.stopPct === val ? undefined : val })}
              >{STOP_LABELS[i]}</button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  panel: {
    background: '#1e293b',
    borderRadius: 8,
    padding: '10px 16px',
    marginBottom: 12,
    borderTop: '3px solid #f59e0b',
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    alignItems: 'flex-end',
  },
  group: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  groupLabel: {
    fontSize: 11,
    color: '#475569',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  },
  btnGroup: {
    display: 'flex',
    gap: 2,
  },
  toggleBtn: {
    background: '#334155',
    color: '#94a3b8',
    border: 'none',
    borderRadius: 4,
    padding: '4px 8px',
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
  },
  toggleBtnActive: {
    background: '#f59e0b',
    color: '#fff',
  },
};